<template>
  <div id="app">
    <div
      class="page-wrapper ice-theme sidebar-bg toggled"
      :class="{ 'sidebar-hidden': close }"
    >
      <nav
        id="sidebar"
        :class="[
          'sidebar-wrapper',
          { nav_open: this.open, nav_close: this.close },
        ]"
      >
        <div class="sidebar-content">
          <div
            class="sidebar-item sidebar-header sidebar-brand-header d-flex flex-column align-items-center justify-content-center"
          >
            <div class="user-pic-logo">
              <img src="@/assets/img/bxb.png" alt="BXB Logo" />
            </div>
            <h5 class="brand-title">{{ user.name }} - Admin</h5>
            <!-- <div v-if="!audioUnlocked" class="audio-unlock-overlay">
                        <button @click="unlockAudio">Enable Sounds</button>
                        </div> -->
            <!-- <div v-if="user">
                            <div class="user-info mt-2 text-center">
                                <div class="user-name" style="color:#fff;font-weight:600;">{{ user.name }}</div>
                            </div>
                        </div> -->
          </div>
          <div class="sidebar-item sidebar-menu">
            <ul>
              <div class="divider">Main Menu</div>
              <li style="margin-top: 12px">
                <router-link
                  :class="[{ active: url === 'dashboard' }]"
                  to="/dashboard"
                >
                  <i class="fas fa-tachometer-alt i-font"></i>
                  <span class="menu-text">Dashboard</span>
                </router-link>
              </li>
              <li style="margin-top: 12px">
                <router-link
                  :class="[{ active: url === 'handicap' }]"
                  to="/handicap"
                >
                  <i class="fas fa-cog i-font"></i>
                  <span class="menu-text">Handicap</span>
                </router-link>
              </li>
              <li style="margin-top: 12px">
                <router-link
                  :class="[{ active: url === 'accumulator' }]"
                  to="/accumulator"
                >
                  <i class="fas fa-cog i-font"></i>
                  <span class="menu-text">Accumulator</span>
                </router-link>
              </li>

              <li style="margin-top: 12px">
                <div class="divider">Utm report</div>
                <router-link
                  :class="[
                    {
                      active:
                        url === 'user-utm-report'
                    },
                  ]"
                  to="/user-utm-report"
                >
                  <i class="fas fa-regular fa-users"></i>
                  <span class="menu-text">User Utm report</span>
                </router-link>
              </li>  
              

              <li style="margin-top: 12px">
                <div class="divider">User Activity</div>
                <router-link
                  :class="[
                    {
                      active:
                        url === 'user-activity-list'
                    },
                  ]"
                  to="/user-activity-list"
                >
                  <i class="fas fa-images i-font"></i>
                  <span class="menu-text">User Activity</span>
                </router-link>
              </li>  
              

              <div class="divider">Payment Manage</div>
              <li>
                <router-link
                  :class="[
                    {
                      active:
                        url === 'deposit-list' ||
                        url === 'deposit-create' ||
                        url === 'deposit-edit',
                    },
                  ]"
                  :to="{
                    name: 'deposit-list',
                    query: {
                      page: 1,
                      orderBy: 'desc',
                      sortKey: 'created_at',
                      name: '',
                    },
                  }"
                >
                  <i class="fas fa-money-bill-wave i-font"></i>
                  <span class="menu-text">
                    Deposit
                    <span v-if="pendingCount > 0" class="badge badge-noti">{{
                      pendingCount
                    }}</span>
                  </span>
                </router-link>
                <router-link
                  :class="[
                    {
                      active:
                        url === 'withdraw-list' ||
                        url === 'withdraw-create' ||
                        url === 'withdraw-edit',
                    },
                  ]"
                  :to="{
                    name: 'withdraw-list',
                    query: {
                      page: 1,
                      orderBy: 'desc',
                      sortKey: 'created_at',
                      name: '',
                    },
                  }"
                >
                  <i class="fas fa-paper-plane i-font"></i>
                  <span class="menu-text">
                    Withdraw
                    <span
                      v-if="pendingWithdrawCount > 0"
                      class="badge badge-noti"
                      >{{ pendingWithdrawCount }}</span
                    >
                  </span>
                </router-link>
                <router-link
                  :class="[
                    {
                      active:
                        url === 'agent-withdraw-list' ||
                        url === 'withdraw-create' ||
                        url === 'withdraw-edit',
                    },
                  ]"
                  :to="{
                    name: 'agent-withdraw-list',
                    query: {
                      page: 1,
                      orderBy: 'desc',
                      sortKey: 'created_at',
                      name: '',
                    },
                  }"
                >
                  <i class="fas fa-paper-plane i-font"></i>
                  <span class="menu-text">Agent Withdraw</span>
                </router-link>
                <router-link
                  :class="[
                    {
                      active:
                        url === 'bank-list' ||
                        url === 'bank-create' ||
                        url === 'bank-edit',
                    },
                  ]"
                  :to="{
                    name: 'bank-list',
                    query: {
                      page: 1,
                      orderBy: 'desc',
                      sortKey: 'created_at',
                      name: '',
                    },
                  }"
                >
                  <i class="fas fa-bank i-font"></i>
                  <span class="menu-text">Bank Info</span>
                </router-link>
              </li>
              <div class="divider">Fixture Manage</div>
              <li style="margin-top: 12px">
                <router-link
                  :class="[{ active: url === 'finished-fixture' }]"
                  to="/finished-fixture"
                >
                  <i class="fas fa-cog i-font"></i>
                  <span class="menu-text">Finished</span>
                </router-link>
              </li>
              <li style="margin-top: 12px">
                <router-link
                  :class="[{ active: url === 'ongoing-fixture' }]"
                  to="/ongoing-fixture"
                >
                  <i class="fas fa-cog i-font"></i>
                  <span class="menu-text">Ongoing</span>
                </router-link>
              </li>
              
              <li>
                <div class="divider">Account Manage</div>
                <router-link
                  :class="[
                    {
                      active:
                        url === 'master-list' ||
                        url === 'master-create' ||
                        url === 'master-edit',
                    },
                  ]"
                  :to="{
                    name: 'master-list',
                    query: {
                      page: 1,
                      orderBy: 'desc',
                      sortKey: 'created_at',
                      name: '',
                      email: '',
                    },
                  }"
                >
                  <i class="fas fa-users i-font"></i>
                  <span class="menu-text">Master</span>
                </router-link>
                <router-link
                  :class="[
                    {
                      active:
                        url === 'agent-list' ||
                        url === 'agent-create' ||
                        url === 'agent-edit',
                    },
                  ]"
                  :to="{
                    name: 'agent-list',
                    query: {
                      page: 1,
                      orderBy: 'desc',
                      sortKey: 'created_at',
                      name: '',
                      email: '',
                    },
                  }"
                >
                  <i class="fas fa-users i-font"></i>
                  <span class="menu-text">Agent</span>
                </router-link>
                <router-link
                  :class="[
                    {
                      active:
                        url === 'member-list' ||
                        url === 'member-create' ||
                        url === 'member-edit',
                    },
                  ]"
                  :to="{
                    name: 'member-list',
                    query: {
                      page: 1,
                      orderBy: 'desc',
                      sortKey: 'created_at',
                      name: '',
                      email: '',
                    },
                  }"
                >
                  <i class="fas fa-users i-font"></i>
                  <span class="menu-text">
                    Member
                    <span
                      v-if="userPendingCount > 0"
                      class="badge badge-noti"
                      >{{ userPendingCount }}</span
                    >
                  </span>
                </router-link>
              </li>

              <li style="margin-top: 12px">
                <div class="divider">UTM</div>
                <router-link
                  :class="[
                    {
                      active:
                        url === 'utm-list' ||
                        url === 'utm-create' ||
                        url === 'utm-edit',
                    },
                  ]"
                  to="/utm-list"
                >
                  <i class="fas fa-images i-font"></i>
                  <span class="menu-text">UTM</span>
                </router-link>
              </li>

              <li style="margin-top: 12px">
                <div class="divider">Banner</div>
                <router-link
                  :class="[
                    {
                      active:
                        url === 'banner-list' ||
                        url === 'banner-create' ||
                        url === 'banner-edit',
                    },
                  ]"
                  to="/banner-list"
                >
                  <i class="fas fa-images i-font"></i>
                  <span class="menu-text">Banner</span>
                </router-link>
              </li>

              <li style="margin-top: 12px">
                <div class="divider">Promotion</div>
                <router-link
                  :class="[
                    {
                      active:
                        url === 'promotion-list' ||
                        url === 'promotion-create' ||
                        url === 'promotion-edit',
                    },
                  ]"
                  to="/promotion-list"
                >
                  <i class="fas fa-ticket i-font"></i>
                  <span class="menu-text">Promotion</span>
                </router-link>
              </li>
              
              <li>
                <div class="divider">Notification</div>
                <router-link
                  :class="[
                    {
                      active:
                        url === 'notification-list' ||
                        url === 'notification-create' ||
                        url === 'notification-edit',
                    },
                  ]"
                  :to="{
                    name: 'notification-list',
                    query: {
                      page: 1,
                      orderBy: 'desc',
                      sortKey: 'created_at',
                      name: '',
                    },
                  }"
                >
                  <i class="fas fa-bell i-font"></i>
                  <span class="menu-text">Notification</span>
                </router-link>
              </li>
              <div class="divider">Report Manage</div>
              <li>
                <router-link
                  :class="[
                    {
                      active:
                        url === 'daily-report-list' ||
                        url === 'daily-report-create' ||
                        url === 'daily-report-edit',
                    },
                  ]"
                  :to="{
                    name: 'daily-report-list',
                    query: {
                      page: 1,
                      orderBy: 'desc',
                      sortKey: 'created_at',
                      name: '',
                    },
                  }"
                >
                  <i class="fas fa-receipt i-font"></i>
                  <span class="menu-text">( Master ) Daily</span>
                </router-link>
                <router-link
                  :class="[
                    {
                      active:
                        url === 'agent-report-list' ||
                        url === 'agent-report-create' ||
                        url === 'agent-report-edit',
                    },
                  ]"
                  :to="{
                    name: 'agent-report-list',
                    query: {
                      page: 1,
                      orderBy: 'desc',
                      sortKey: 'created_at',
                      name: '',
                    },
                  }"
                >
                  <i class="fas fa-receipt i-font"></i>
                  <span class="menu-text">( Master ) Agent</span>
                </router-link>
                <router-link
                  :class="[
                    {
                      active:
                        url === 'member-report-list' ||
                        url === 'member-report-create' ||
                        url === 'member-report-edit',
                    },
                  ]"
                  :to="{
                    name: 'member-report-list',
                    query: {
                      page: 1,
                      orderBy: 'desc',
                      sortKey: 'created_at',
                      name: '',
                    },
                  }"
                >
                  <i class="fas fa-receipt i-font"></i>
                  <span class="menu-text">( Master ) Member</span>
                </router-link>
                <router-link
                  :class="[{ active: url === 'daily-report-nm-list' }]"
                  :to="{
                    name: 'daily-report-nm-list',
                    query: {
                      page: 1,
                      orderBy: 'desc',
                      sortKey: 'created_at',
                      name: '',
                    },
                  }"
                >
                  <i class="fas fa-receipt i-font"></i>
                  <span class="menu-text">( No Master ) Daily</span>
                </router-link>
                <router-link
                  :class="[{ active: url === 'member-report-nm-list' }]"
                  :to="{
                    name: 'member-report-nm-list',
                    query: {
                      page: 1,
                      orderBy: 'desc',
                      sortKey: 'created_at',
                      name: '',
                    },
                  }"
                >
                  <i class="fas fa-receipt i-font"></i>
                  <span class="menu-text">( No Master ) Member</span>
                </router-link>
              </li>
            </ul>
          </div>
          <!-- sidebar-menu  -->
        </div>
        <!-- sidebar-footer  -->
        <div class="sidebar-footer">
          <!-- <div>
                        <a href="#" @click="logout()">
                            <i class="fa fa-power-off"></i>
                        </a>
                    </div>
                    <div class="pinned-footer">
                        <a href="#">
                            <i class="fas fa-ellipsis-h"></i>
                        </a>
                    </div> -->
        </div>
      </nav>
      <div
        class="layer"
        @click="closeNav()"
        :class="{ layer_open: overlay }"
      ></div>
      <!-- page-content  -->
      <main class="page-content">
        <AppHeader
          :sidebarOpen="!close"
          @toggle-menu="openNav"
          @toggle-sidebar="toggleSidebar"
          @dollar-click="onDollarClick"
        >
        </AppHeader>
        <router-view :class="routerViewClass" />
      </main>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import AppHeader from "@/components/AppHeader.vue";
import depositSoundFile from "@/assets/drop-collect.mp3";
import withdrawSoundFile from "@/assets/drop-collect.mp3";
import userSoundFile from "@/assets/drop-collect.mp3";

// You need a silent MP3 file in your assets folder
import silentAudioFile from "@/assets/silent.mp3";

export default {
  name: "admin",
  data() {
    return {
      routerViewClass: "my-custom-class",
      saleCount: "",
      transferCount: "",
      productCount: "",
      check: true,
      close: false, // sidebar visible by default
      open: true,
      overlay: false, // controls the layer overlay
      name: "",
      role: "",
      url: "",
      lastCount: 0, // last known deposit count
      pendingCount: 0, // badge number
      lastWithdrawCount: 0, // last known withdrawal count
      pendingWithdrawCount: 0, // badge number
      userPendingCount: 0, // badge number
      audioUnlocked: false,
      depositAudio: null,
      withdrawAudio: null,
      userAudio: null,
      permissions: "",
      user: null,
      dropdowns: {
        hymn: false,
        bible: false,
        notification: false,
        event: false,
      },
    };
  },
  components: {
    AppHeader,
  },
  methods: {
    // Unlock audio automatically
    unlockAudio() {
      if (this.audioUnlocked) return; // Prevent multiple initializations
      this.audioUnlocked = true;

      // Create and preload audio elements
      this.depositAudio = new Audio(depositSoundFile);
      this.withdrawAudio = new Audio(withdrawSoundFile);
      this.userAudio = new Audio(userSoundFile);
      this.depositAudio.load();
      this.withdrawAudio.load();
      this.userAudio.load();

      console.log("Audio unlocked! Sounds can play now.");
    },
    // Play deposit sound
    playDepositSound() {
      if (!this.audioUnlocked || !this.depositAudio) return;
      this.depositAudio.currentTime = 0;
      this.depositAudio.play().catch((err) => console.warn(err));
    },
    // Play withdraw sound
    playWithdrawSound() {
      if (!this.audioUnlocked || !this.withdrawAudio) return;
      this.withdrawAudio.currentTime = 0;
      this.withdrawAudio.play().catch((err) => console.warn(err));
    },
    // Play user sound
    playUserSound() {
      if (!this.audioUnlocked || !this.userAudio) return;
      this.userAudio.currentTime = 0;
      this.userAudio.play().catch((err) => console.warn(err));
    },
    toggleSidebar() {
      // Only toggle sidebar, not overlay
      this.open = !this.open;
      this.close = !this.close;
    },
    onDollarClick() {
      // You can still call unlockAudio() here as a fallback
      this.unlockAudio();
      alert("Dollar button clicked!");
    },
    ...mapActions({
      checkDepositAction: "checkDepositAction",
      checkWithdrawAction: "checkWithdrawAction",
      checkUserAction: "checkUserAction",
    }),
    openNav: function () {
      // Open sidebar and show overlay (for mobile/menu)
      this.open = true;
      this.close = false;
      this.overlay = true;
    },
    closeNav: function () {
      // Hide sidebar and overlay
      this.open = false;
      this.close = true;
      this.overlay = false;
    },
    toggleDropdown(dropdown) {
      this.dropdowns[dropdown] = !this.dropdowns[dropdown];
    },
    checkPermission: function (key) {
      if (key in this.permissions) {
        return true;
      } else {
        return false;
      }
    },
    logout() {
      window.localStorage.removeItem("token");
      window.localStorage.removeItem("user");
      window.localStorage.removeItem("church");
      this.$router.replace("/login");
    },
    defaultMenu() {},
    async checkDeposits() {
      try {
        const response = await this.checkDepositAction({});

        if (response.success) {
          const { count, latest } = response.data;
          // update badge count
          this.pendingCount = count;

          // show browser notification if new deposits came
          if (count > this.lastCount) {
            if (Notification.permission === "granted") {
              new Notification("💰 New Deposit Pending", {
                body: `User ${latest.description} deposited ${latest.amount}`,
              });
            }

            this.playDepositSound();
          }
          this.lastCount = count;
        } else {
          console.error("Deposit check failed:", response.message);
        }
      } catch (err) {
        console.error("Error checking deposits:", err);
      }
    },
    async checkWithdraw() {
      try {
        const response = await this.checkWithdrawAction({});

        if (response.success) {
          const { count, latest } = response.data;
          // update badge count
          this.pendingWithdrawCount = count;

          // show browser notification if new withdrawals came
          if (count > this.lastWithdrawCount) {
            if (Notification.permission === "granted") {
              new Notification("💰 New Withdrawal Pending", {
                body: `User ${latest.description} withdrew ${latest.amount}`,
              });
            }

            this.playWithdrawSound();
          }
          this.lastWithdrawCount = count;
        } else {
          console.error("Withdraw check failed:", response.message);
        }
      } catch (err) {
        console.error("Error checking withdrawals:", err);
      }
    },
    async checkUsers() {
      try {
        const response = await this.checkUserAction({});

        if (response.success) {
          const { count, latest } = response.data;
          // update badge count
          this.userPendingCount = count;

          // show browser notification if new users came
          if (count > this.lastUserCount) {
            if (Notification.permission === "granted") {
              new Notification("🆕 New User Pending", {
                body: `User ${latest.name} just registered.`,
              });
            }

            this.playUserSound();
          }
          this.lastUserCount = count;
        } else {
          console.error("User check failed:", response.message);
        }
      } catch (err) {
        console.error("Error checking users:", err);
      }
    },
  },
  watch: {
    $route(to, from) {
      this.url = to.name;
    },
  },
  mounted() {
    this.url = this.$route.name;
    // Get user info from localStorage
    const userStr = window.localStorage.getItem("user");
    if (userStr) {
      try {
        this.user = JSON.parse(userStr);
      } catch (e) {
        this.user = null;
      }
    }

    // Attempt to play a silent audio file to unlock the context
    const silentAudio = new Audio(silentAudioFile);
    silentAudio.muted = true;
    silentAudio
      .play()
      .then(() => {
        this.unlockAudio();
      })
      .catch((err) => {
        console.error("Autoplay failed:", err);
        // The silent audio trick failed, so fall back to user interaction.
        // You should probably display a message to the user here.
      });

    if (Notification.permission !== "granted") {
      Notification.requestPermission().then((permission) => {
        console.log("Notification permission:", permission);
      });
    }

    this.checkDeposits();
    this.checkWithdraw();
    this.checkUsers();
    // Poll every 3 seconds
    setInterval(() => {
      this.checkDeposits();
      this.checkWithdraw();
      this.checkUsers();
    }, 3000);
  },
};
</script>
<style lang="scss">
@import "https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css";
@import "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.2/css/all.min.css";
@import "../assets/css/main.css";
@import "../assets/css/sidebar-themes.css";
@import "../assets/css/datepicker.scss";
@import "~vue-multiselect/dist/vue-multiselect.min.css";

// Custom badge style for notification
.badge-noti {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #e74c3c;
  color: #fff;
  border-radius: 50% !important;
  width: 24px;
  height: 24px;
  font-size: 0.95rem;
  font-weight: 700;
  box-shadow: 0 2px 8px rgba(231, 76, 60, 0.15);
  border: 2px solid #fff;
  margin-left: 8px;
  vertical-align: middle;
  padding: 0;
  transition: background 0.2s, color 0.2s;
}

.page-wrapper.sidebar-hidden {
  margin-left: 0 !important;
}
.sidebar-hidden .page-content {
  width: 100vw !important;
  max-width: 100vw !important;
  left: 0 !important;
  margin: 0 !important;
  padding-left: 0 !important;
  transition: width 0.3s, max-width 0.3s, left 0.3s, margin 0.3s, padding 0.3s;
}
.sidebar-hidden .main-header {
  width: 100vw !important;
  max-width: 100vw !important;
  left: 0 !important;
  margin: 0 !important;
  padding-left: 0 !important;
  transition: width 0.3s, max-width 0.3s, left 0.3s, margin 0.3s, padding 0.3s;
}
/* Fallback for nav_open/nav_close if not present in your main CSS */
.nav_open {
  left: 0 !important;
  transition: left 0.3s;
}
.nav_close {
  left: -280px !important;
  transition: left 0.3s;
}
.divider {
  display: flex;
  align-items: center;
  text-align: center;
  color: #fff;
  font-weight: 600;
  font-size: 15px;
  letter-spacing: 1px;
  margin: 18px 0 10px 0;
  padding: 0 0 0 0;
  position: relative;
  background: linear-gradient(90deg, #2b3a42 0%, #4f8a8b 100%);
  border-radius: 8px;
  height: 36px;
  box-shadow: 0 2px 8px rgba(44, 62, 80, 0.08);
  justify-content: center;
}
.divider::before,
.divider::after {
  content: "";
  flex: 1;
  height: 2px;
  background: linear-gradient(90deg, #4f8a8b 0%, #fff 100%);
  margin: 0 12px;
  border-radius: 2px;
  opacity: 0.5;
}
.divider::before {
  margin-left: 18px;
}
.divider::after {
  margin-right: 18px;
}

.sidebar-brand-header {
  background: linear-gradient(90deg, #2b3a42 0%, #4f8a8b 100%);
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  padding: 24px 0 12px 0;
  margin-bottom: 8px;
  box-shadow: 0 2px 8px rgba(44, 62, 80, 0.08);
}
.user-pic-logo {
  width: 64px;
  height: 64px;
  background: #bedbff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(44, 62, 80, 0.1);
  margin-bottom: 8px;
}
.user-pic-logo img {
  width: 48px;
  height: 48px;
  object-fit: contain;
  border-radius: 50%;
}
.brand-title {
  color: #fff;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 2px;
  margin: 0;
  text-align: center;
  text-shadow: 0 2px 8px rgba(44, 62, 80, 0.1);
}

.my-custom-class {
  width: 90%;
}

.back-btn {
  background: #fff;
  border: none;
  color: #4f8a8b;
  border-radius: 50%;
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  box-shadow: 0 2px 8px rgba(44, 62, 80, 0.1);
  font-size: 1.2rem;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  outline: none;
}
.back-btn:hover {
  background: #4f8a8b;
  color: #fff;
}

//Table

.common-table {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #bedbff;
  width: 100%;
  margin-bottom: 0;
  border-collapse: collapse;
}
.common-table thead {
  background: #bedbff;
}
.common-table th,
.common-table td {
  vertical-align: middle;
  border-bottom: 1px solid #bedbff;
  padding: 14px 16px;
  font-size: 1rem;
}
.common-table tbody td {
  padding: 10px 12px;
  border-bottom: 1px solid #e9ecef;
  vertical-align: middle;
}
.common-table th {
  font-weight: 700;
  letter-spacing: 0.5px;
  text-align: left;
  color: #fff;
  background: #4e8889;
}
.common-table tbody tr {
  transition: background 0.2s;
}
.common-table tbody tr:hover {
  background: #e6f0ff;
}
.common-table .btn-option {
  background: transparent;
  border: 1px solid #bedbff;
  border-radius: 6px;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  margin-right: 4px;
  color: #4f8a8b;
  transition: background 0.2s, color 0.2s, border 0.2s;
}
.common-table .btn-action {
  background: transparent;
  border: 1px solid #bedbff;
  border-radius: 6px;
  // width: 32px;
  // height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  margin-right: 4px;
  color: #4f8a8b;
  transition: background 0.2s, color 0.2s, border 0.2s;
}
.common-table .btn-option:hover {
  background: #bedbff;
  color: #222;
  border-color: #bedbff;
}
.common-table .text-danger.btn-option:hover {
  background: #e74c3c;
  color: #fff;
  border-color: #e74c3c;
}
.common-table .text-primary.btn-option:hover {
  background: #3498db;
  color: #fff;
  border-color: #3498db;
}
.common-table th:last-child,
.common-table td:last-child {
  text-align: right;
}
.table-pagination-minimal {
  margin-top: 18px;
  width: 100%;
}
.table-pagination-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
}
.table-info-minimal.left-align {
  margin-bottom: 0;
  margin-right: auto;
}
.table-info-minimal {
  color: #222;
  font-size: 1rem;
  margin-bottom: 0.5rem;
  font-weight: 500;
  background: #f8faff;
  border-radius: 6px;
  padding: 4px 16px;
  border: 1px solid #e3eafc;
  box-shadow: 0 1px 4px 0 rgba(190, 219, 255, 0.07);
}
.table-info-minimal span {
  color: #4f8a8b;
  font-weight: 700;
  margin: 0 2px;
}
.pagination-minimal {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 4px 0 rgba(190, 219, 255, 0.07);
  padding: 4px 12px;
  border: 1px solid #e3eafc;
}
.pagination-minimal ul {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  gap: 4px;
}
.pagination-minimal li {
  border-radius: 5px;
  overflow: hidden;
}
.pagination-minimal button {
  min-width: 32px;
  min-height: 32px;
  padding: 0 10px;
  border: none;
  background: #f8faff;
  color: #4f8a8b;
  font-size: 1rem;
  font-weight: 500;
  border-radius: 5px;
  transition: background 0.18s, color 0.18s, box-shadow 0.18s;
  cursor: pointer;
  outline: none;
  box-shadow: none;
}
.pagination-minimal li.active button {
  background: #bedbff;
  color: #232946;
  font-weight: 700;
  box-shadow: 0 2px 8px 0 rgba(190, 219, 255, 0.12);
}
.pagination-minimal li.disabled button {
  background: #f0f2f7;
  color: #b0b0b0;
  cursor: not-allowed;
  pointer-events: none;
}
.pagination-minimal button:hover:not(:disabled) {
  background: #e6f0ff;
  color: #232946;
}
.b-calendar-inner {
  width: 385px !important;
}
// Table Border
table,
th,
td {
  border: 1px solid #dee2e6;
  border-collapse: collapse;
}
.agent-color {
  background-color: #41f80946 !important;
}
.master-color {
  background-color: #eb06523a !important;
}
.member-color {
  background-color: #0d47e93a !important;
}
.company-color {
  background-color: #eecb0838 !important;
}
</style>
